import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { PromotionalAdContext as Context } from './ContextCreator';

export const PromotionalAdProvider = ({ isMobile, children }) => {
    const [adState, setAdState] = useState({ ads: [] });
    useEffect(() => {
        if (adState.cb) {
            adState.cb();
        }
    }, [adState]);
    const getAdAtPosition = (position, pageKey) => {
        const _updateAdByPosition = (ad, cb = () => {}) => {
            const { ads } = adState;
            if (ads[position] && ad.adinfo) ads[position] = ad;
            else ads[position] = ad;
            setAdState({ ads, cb, getAdAtPosition });
        };

        const _fetchPromotionalAd = async () => {
            try {
                const res = await axios.post(
                    '/api/promotional-ad/master-feed-ad',
                    {
                        isMobile,
                        pageKey,
                    }
                );

                _updateAdByPosition({
                    isLoading: false,
                    adInfo: res.data.data,
                });
            } catch (e) {
                _updateAdByPosition(
                    {
                        isLoading: false,
                        adInfo: null,
                    },
                    () => {}
                );
            }
        };
        const ad = adState.ads ? adState.ads[position] : false;
        if (!ad && pageKey) {
            _fetchPromotionalAd(position);
        }
        return ad;
    };
    useEffect(() => {
        setAdState({
            ads: [
                {
                    isLoading: true,
                    adInfo: null,
                },
            ],
            getAdAtPosition,
        });
    }, []);

    return <Context.Provider value={adState}>{children}</Context.Provider>;
};

PromotionalAdProvider.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
};

PromotionalAdProvider.defaultProps = {};

export const PromotionalAdConsumer = Context.Consumer;
